document.addEventListener("DOMContentLoaded", () => {
  const menu = document.querySelector("[data-mobile-menu]");
  const open = document.querySelector("[data-menu-open]");
  const close = document.querySelector("[data-menu-close]");
  const setMenu = (visible) => {
    if (!menu) return;
    menu.hidden = !visible;
    menu.setAttribute("aria-hidden", String(!visible));
    open?.setAttribute("aria-expanded", String(visible));
    document.body.classList.toggle("menu-is-open", visible);
    if (visible) close?.focus();
  };
  open?.addEventListener("click", () => setMenu(true));
  close?.addEventListener("click", () => setMenu(false));
  menu?.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => setMenu(false)));
  document.addEventListener("keydown", (event) => { if (event.key === "Escape") setMenu(false); });

  document.querySelectorAll("[data-product-slider]").forEach((slider) => {
    const slides = [...slider.querySelectorAll("[data-slide]")];
    const thumbs = [...slider.querySelectorAll("[data-slide-thumb]")];
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      thumbs.forEach((thumb, i) => thumb.classList.toggle("is-active", i === active));
      const status = slider.querySelector("[data-slide-status]");
      if (status) status.textContent = (active + 1) + " / " + slides.length;
    };
    slider.querySelector("[data-slide-prev]")?.addEventListener("click", () => show(active - 1));
    slider.querySelector("[data-slide-next]")?.addEventListener("click", () => show(active + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener("click", () => show(i)));
    if (slides.length) show(0);
  });

  const lightbox = document.querySelector("[data-product-lightbox]");
  const lightboxImage = lightbox?.querySelector("[data-lightbox-image]");
  const zoomLevel = lightbox?.querySelector("[data-zoom-level]");
  let scale = 1;
  const applyZoom = () => {
    if (lightboxImage) lightboxImage.style.transform = "scale(" + scale + ")";
    if (zoomLevel) zoomLevel.textContent = Math.round(scale * 100) + "%";
  };
  document.querySelectorAll("[data-image-zoom]").forEach((button) => button.addEventListener("click", () => {
    if (!lightbox || !lightboxImage) return;
    lightboxImage.src = button.dataset.zoomSrc;
    scale = 1;
    applyZoom();
    lightbox.showModal();
    document.body.classList.add("lightbox-is-open");
  }));
  const closeLightbox = () => {
    lightbox?.close();
    document.body.classList.remove("lightbox-is-open");
  };
  lightbox?.querySelector("[data-lightbox-close]")?.addEventListener("click", closeLightbox);
  lightbox?.addEventListener("click", (event) => { if (event.target === lightbox) closeLightbox(); });
  lightbox?.addEventListener("close", () => document.body.classList.remove("lightbox-is-open"));
  lightbox?.querySelector("[data-zoom-in]")?.addEventListener("click", () => { scale = Math.min(3, scale + .25); applyZoom(); });
  lightbox?.querySelector("[data-zoom-out]")?.addEventListener("click", () => { scale = Math.max(.75, scale - .25); applyZoom(); });

  document.querySelectorAll("[data-cinematic-product]").forEach((section) => {
    const video = section.querySelector("video");
    if (!video) return;
    video.muted = true;
    video.playsInline = true;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      });
    }, { threshold: .3 });
    observer.observe(section);
  });
});
